<template>
  <div>
    <Head title="Packed Orders" />
    <h1 class="mb-8 text-3xl font-bold">Delivery Run: {{ delivery_run.number }}</h1>
    <div class="mb-6">
      <h2>Provider: {{ user.name }}</h2>
    </div>
    <div class="mb-3">
      <Link
        href="/dispatches/delivery-runs"
        class="text-orange-600 hover:text-orange-500 mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6 inline"
          style="display: inline !important"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
          />
        </svg>
        Back
      </Link>
    </div>
    <div class="grid grid-cols-6 gap-4">
  <div class="col-start-1 col-end-3 ...">
    <search-filter
        v-model="search.search"
        class="mr-4 w-full max-w-md"
        @reset="reset"
      />
  </div>
  <div class="col-end-7 col-span-2 ...">
    <div class="flex justify-end">
        <button
          id="dropdownDividerButton"
          data-dropdown-toggle="dropdownDivider"
          class="text-white btn-orange bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          type="button"
        >
          Actions
          <svg
            class="w-2.5 h-2.5 ms-3 mx-1"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 4 4 4-4"
            />
          </svg>
        </button>

        <!-- Dropdown menu -->
        <div
          id="dropdownDivider"
          class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600"
        >
          <ul
            class="py-2 text-sm text-gray-700 dark:text-gray-200"
            aria-labelledby="dropdownDividerButton"
          >
          <li >
                <a href="#" class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white" @click="downloadGatePass">Gate Pass</a>
              </li>
            <li>
              <a
                 :href="`/deliveryruns/${delivery_run.id}/download-dr-invoices`"
                  target="_blank"
                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                >Invoices</a
              >
            </li>
            <li>
              <a
                 :href="`/deliveryruns/${delivery_run.id}/download-dr-delivery-notes`"
                  target="_blank"
                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                >Delivery Notes</a
              >
            </li>
            <li>
                <a href="#" @click="closeDRModel(delivery_run)" class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Close DR</a>
              </li>
          </ul>
        </div>
      </div>
  </div>
</div>
    <div v-show="false" class="mb-6 flex">
      <search-filter
        v-model="search.search"
        class="mr-4 w-full max-w-md"
        @reset="reset"
      />

      <dropdown v-show="true" placement="bottom-end flex justify-end">
        <template #default>
          <loading-button class="btn-orange px-3 py-2 text-xs float-right" type="submit">
            Actionsxx
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6 ml-1"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19.5 8.25l-7.5 7.5-7.5-7.5"
              />
            </svg>
          </loading-button>
        </template>
        <template #dropdown>
          <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
            <ul>
              <li class="mt-2 p-2">
                <a href="#" class="mt-1" @click="downloadGatePass">Download Gate Pass</a>
              </li>
              <li class="mt-2 p-2">
                <a
                  :href="`/deliveryruns/${delivery_run.id}/download-dr-invoices`"
                  target="_blank"
                  class="mt-1"
                  >Print Invoices/D Notes</a
                >
              </li>
              <li class="mt-2 p-2">
                <a href="#" class="mt-1" @click="closeDRModel(delivery_run)">Close DR</a>
              </li>
            </ul>
          </div>
        </template>
      </dropdown>
      <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <a
          v-show="false"
          ref="dwnLoadGatePass"
          class="btn btn-orange text-xs cursor-pointer ml-1 mr-1"
          :href="`/delivery-runs/${delivery_run.id}/gate-pass/pdf${pdfUrl(
            delivery_run.id
          )}`"
          target="__blank"
          title="Download"
        >
          <span>Download Invoice</span>
        </a>
      </span>

    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Date</th>
          <th class="pb-3 pt-3 px-3">Date Picked</th>
          <th class="pb-3 pt-3 px-3">Order Number</th>
          <th class="pb-3 pt-3 px-3">Customer</th>
          <th class="pb-3 pt-3 px-3">Contact</th>
          <th class="pb-3 pt-3 px-3">Physical Address</th>
          <th class="pb-3 pt-3 px-3">Quantity Packed</th>
          <th class="pb-3 pt-3 px-3">Amount</th>
          <th class="pb-3 pt-3 px-3">Volume</th>
          <th class="pb-3 pt-3 px-3">Status</th>
          <th class="pb-3 pt-3 px-3 text-end" />
        </tr>
        <tr
          v-for="list in orders.data"
          :key="list.id"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${delivery_run.id}/orders/${list.order_id}/packed/skus`"
              title=""
            >
              {{ list.date }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${delivery_run.id}/orders/${list.order_id}/packed/skus`"
              title=""
            >
              {{ list.date_closed }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${delivery_run.id}/orders/${list.order_id}/packed/skus`"
              title=""
            >
              {{ list.order_no }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${delivery_run.id}/orders/${list.order_id}/packed/skus`"
              title=""
            >
              {{ list.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${delivery_run.id}/orders/${list.order_id}/packed/skus`"
              title=""
            >
              {{ list.contact }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${delivery_run.id}/orders/${list.order_id}/packed/skus`"
              title=""
            >
              {{ list.physical_address }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${delivery_run.id}/orders/${list.order_id}/packed/skus`"
              title=""
            >
              {{ list.quantity }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${delivery_run.id}/orders/${list.order_id}/packed/skus`"
              title=""
            >
              {{ list.amount }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${delivery_run.id}/orders/${list.order_id}/packed/skus`"
              title=""
            >
              {{ list.volume }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${delivery_run.id}/orders/${list.order_id}/packed/skus`"
              title=""
            >
              {{ list.status }}
            </Link>
          </td>
          <td class="w-px border-t">
            <a
              :href="`#/dispatches/delivery-runs/${delivery_run.id}/packed/orders/${list.order_id}/skus`"
              class="flex items-center justify-end pr-3"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M8.25 4.5l7.5 7.5-7.5 7.5"
                />
              </svg>
            </a>
          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="5">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="orders.links" />
  </div>
  <!--modal content-->
  <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to close a delivery run
              <strong>{{ delivery_run.number }}</strong
              >. Do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5"
                @click="postDR(delivery_run)"
              >
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeModal"
              >
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="showInvoices" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left w-1/2 overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Order Invoices</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <ul>
              <li v-for="(ord, indx) in orders.data" :key="indx" class="p-2">
                <a
                  :href="`/orders/${ord.id}/pdf${url(ord.id)}`"
                  download
                  target="__blank"
                  title="Download"
                  class="p-2 text-orange-500"
                >
                  Download invoice for Order: {{ ord.order_no }}
                </a>
              </li>
            </ul>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeDownloadInvoices"
              >
                close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import pickBy from "lodash/pickBy";
import Layout from "@/Shared/Layout";
import throttle from "lodash/throttle";
import mapValues from "lodash/mapValues";
import SearchFilter from "@/Shared/SearchFilter";
import Pagination from "@/Shared/Pagination";
import SelectInput from "@/Shared/SelectInput";
import Dropdown from "@/Shared/Dropdown";
import LoadingButton from "@/Shared/LoadingButton";

export default {
  components: {
    Head,
    Link,
    SearchFilter,
    Pagination,
    SelectInput,
    Dropdown,
    LoadingButton,
  },
  layout: Layout,
  props: {
    filters: Object,
    user: Object,
    orders: Object,
    delivery_run: Object,
    is_order_complete: Number,
  },
  data() {
    return {
      search: {
        search: this.filters.search,
      },
      isOpen: false,
      download_options: null,
      showInvoices: false,
      dwnLoadGatePass: null,
      drActions: ["Download Invoices", "Download Gate Pass"],
    };
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(
          `/dispatches/delivery-runs/${this.delivery_run.id}/packed/orders`,
          pickBy(this.search),
          { preserveState: true }
        );
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null);
    },
    closeDRModel() {
      this.isOpen = true;
    },
    closeModal() {
      this.isOpen = false;
    },
    downloadOptions() {
      if (this.download_options === "Download Gate Pass") {
        this.$refs.dwnLoadGatePass.click();
      }
      if (this.download_options === "Download Invoices") {
        this.showInvoices = true;
      }
    },
    downloadGatePass() {
      this.$refs.dwnLoadGatePass.click();
    },
    closeDownloadInvoices() {
      this.showInvoices = false;
    },
    pdfUrl(dr) {
      let query = "";
      if (dr) {
        query += `drid=${dr}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
    url(order) {
      let query = "";
      if (order) {
        query += `oid=${this.order}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
    postDR(delivery_run) {
      const data = {};
      data.delivery_run_id = delivery_run.id;
      data._method = "POST";
      this.$inertia.post(`/delivery-runs/${this.delivery_run.id}/orders/close`, data, {
        onSuccess: () => {
          this.isOpen = false;
        },
      });
    },
  },
};
</script>
